// Unpublished Work © 2025 Deere & Company.

import React from 'react';
import {connect} from 'react-redux';
import {closeDialog as closeReduxDialog} from 'Store/actions/dialogs';
import dialogTypes from 'Ui/components/common/dialog-types';
import PropTypes from 'prop-types';
import MowingDirectionsSettings from 'Src/ui-core/components/settings/labor/mowing-directions-settings';
import {Dialog, Box} from '@deere/isg.component-library';

function MowingDirectionsSettingsDialog(props) {
    const {
        closeDialog,
        translations
    } = props;

    return (
        <Dialog
            closeHandler={closeDialog}
            open={true}
            title={translations.ONLINK_MOWING_DIRECTIONS}
            translations={translations}
            width='lg'
        >
            <Box
                display='flex'
                height='70vh'
            >
                <MowingDirectionsSettings translations={translations}/>
            </Box>
        </Dialog>
    );
}

MowingDirectionsSettingsDialog.propTypes = {
    closeDialog: PropTypes.func,
    translations: PropTypes.translations
};

export function mapDispatchToProps(dispatch) {
    return {
        closeDialog() {
            dispatch(closeReduxDialog(dialogTypes.MOWING_DIRECTIONS_SETTINGS_DIALOG));
        }
    };
}

export default connect(null, mapDispatchToProps)(MowingDirectionsSettingsDialog);
